import React from "react";
// import { cufrontIcons } from "../assets/icons/icons";
import { IoLogOutOutline } from "react-icons/io5";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { Logout } from "../apis/authSetup";
// import { useTranslation } from "react-i18next";
import Menu from "./Menu";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { Logout } from "../../_helper/constant/auth";

const ProfileComponent = ({ filteredUserData }) => {
  // const { t } = useTranslation();
  const navigate = useNavigate();

  const menuItems = Menu();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleItemClick = (link, id) => {
    const newParams = new URLSearchParams(searchParams);
    if (id) {
      // navigate(`${link}/${id}`);
      newParams.set("option", link);
      newParams.set("id", id);
      setSearchParams(newParams);
    } else {
      // navigate(`${link}`);
      newParams.set("option", link);
      // newParams.set("id", id);
      setSearchParams(newParams);
    }
  };

  // const handleLogout = () => {
  //   Logout();
  //   window.location.href = "https://ndhealthwellclinic.com/";
  // };

  return (
    <div className="">
      {menuItems.map((item, index) => (
        <div
          key={index}
          className="h-[84px] px-3 flex justify-between items-center cursor-pointer border-b-[0.5px] border-[#00000033]"
          onClick={() =>
            handleItemClick(
              item?.link,
              item?.includeId ? filteredUserData?.id : undefined
            )
          }
        >
          <div className="flex items-center gap-5">
            <div className="w-[50px]">
              <span>{item?.icon}</span>
            </div>
            <div className="text-[#2D2D2D] hover:text-black font-[500] ">
              {item.label}
            </div>
          </div>
          <div className="w-[24px] h-[24px]">
            <img
              className="w-full h-full"
              src={cufrontIcons?.rightArrow}
              alt=""
            />
          </div>
        </div>
      ))}
      <div
        className="h-[84px] px-3 flex justify-between items-center cursor-pointer border-b-[0.5px] border-[#00000033]"
        // onClick={handleLogout}
      >
        <div className="flex items-center gap-5">
          <div className="w-[50px]">
            <IoLogOutOutline size={35} color="#999999" />
          </div>
          <div
            className="text-[#2D2D2D] hover:text-black font-[500]"
            onClick={() => {
              Logout();
              navigate("/login");
            }}
          >
            Log Out
          </div>
        </div>
        <div className="w-[24px] h-[24px]">
          <img
            className="w-full h-full"
            src={cufrontIcons?.rightArrow}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
